import { Type } from '@angular/core';
import { NotificationConfig, NotificationEvent } from './notification.model';

export const getNotificationComponent = (
    config: NotificationConfig,
    typeId: NotificationEvent['typeId'],
) =>
    typeof config.components === 'object'
        ? (config.components[typeId] ?? config.components.default)
        : config.components;

export const bindNotificationComponent = (
    component: Type<unknown>,
    ...typeIds: NotificationEvent['typeId'][]
): Partial<Record<NotificationEvent['typeId'], Type<unknown>>> =>
    typeIds.reduce(
        (components, typeId) => ({ ...components, [typeId]: component }),
        {},
    );
